/**
 *
 * File: localStorage.js
 *
 * Purpose: Local (browser) storage of DrivePartner app.
 *
 * Author:   Thomas Burgard (Software development)
 * Created:  19.04.2023
 * Modified: 19.04.2023
 *
 * Copyright (c) BurgarDental Zahntechnik Softwareentwicklung & Beratung 2023
 *
 */

/**
 * Add username & passenger data to local storage.
 * 
 * @param {*} user userData 
 */
export const addUserToLocalStorage = (userData) => {
  localStorage.setItem("username", JSON.stringify(userData.username)); // Passenger username
  localStorage.setItem(
    "passengerData",
    JSON.stringify(userData.passengerData.PassengerData)
  );}; // Passenger ID

/**
 * Remove username & passenger data from local storage. 
 */
export const removeUserFromLocalStorage = () => {
  localStorage.removeItem("username");
  localStorage.removeItem("passengerData");
};

/**
 * Get username from local storage.
 * 
 * @returns username from local storage
 */
export const getUserFromLocalStorage = () => {
  const result = localStorage.getItem("username");
  const username = result ? JSON.parse(result) : null;
  return username;
};

/**
 * Get passenger data from local storage.
 * 
 * @returns passengerData from local storage
 */
export const getPassengerDataFromLocalStorage = () => {
  const result = localStorage.getItem("passengerData");
  const passengerData = result ? JSON.parse(result) : null;
  return passengerData;
};
